
import React, { Component, useEffect, useState, useMemo, useRef } from "react";
import './index.scss'
import { connect } from 'react-redux';
import MTabBar from '../../../../../components/MTabBar';
import introduction_1Png from '../../../../../images/home/introduction_1.png'

import LocationOnIcon from '@material-ui/icons/LocationOn';
import {
  SearchOutlined
} from '@ant-design/icons';
import { Tabs } from 'antd';
import ZoneItem from './ZoneItem'
import CityTabs from "../Zone/components/CityTabs";
import {
  Popover,
  Button
} from 'antd';
import { initialWebWillMount, refreshCityName } from "../../../actions/ZoneAction";
import { classifyRecommendApi } from "../../../WebService";
import HttpUtils from "../../../../../utils/HttpUtils";
import { CACHE_ACCESS_TOKEN } from "../../../../../constants/Profile";
import { RoutePath } from "../../../../../constants/RoutePath";

const Home = ({ dispatch, router, cityName }) => {
  const token = localStorage.getItem(CACHE_ACCESS_TOKEN)

  let tabs = {
    singleZones: '单层库',
    multiRampZones: '多层坡道库',
    multiElevatorZones: '多层电梯库',
    multiElevatorRampZones: '多层坡道电梯库',
  }
  const [tabList, setTabList] = useState([])
  const [activeKey, setActiveKey] = useState('')
  const [classifyRecommend, setClassifyRecommend] = useState({})


  const list = activeKey ? classifyRecommend[activeKey] : []

  useEffect(() => {
    cityName && getClassifyRecommend()
  }, [cityName])

  const getClassifyRecommend = () => {
    HttpUtils.post(
      classifyRecommendApi,
      {
        zoneCity: cityName,
        amount: 12,
      },
      (response) => {
        setClassifyRecommend(response.data)
        let classifyRecommend = response.data

        let keys = Object.keys(classifyRecommend)
        let r = []
        for (let key of keys) {
          if (classifyRecommend[key].length > 0) {
            r.push({ name: tabs[key], key })
          }
        }
        setTabList(r)
        if (r && r.length > 0) {
          setActiveKey(r[0].key)
        }
      }
    )
  }

  useEffect(() => {
    initialWebWillMount({ cityName, dispatch });
  }, [])

  const [cityTabsOpen, setCityTabsOpen] = useState(false)

  const _handleSelectCity = (cityName) => {
    dispatch(refreshCityName(cityName));
    setCityTabsOpen(false)
  }

  const targetRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (targetRef.current && !targetRef.current.contains(event.target)) {
        // 点击了目标元素以外的区域
        console.log('点击了目标元素以外的区域');
        // 在这里执行你想要的操作
        setCityTabsOpen(false)
      }
    };

    // 添加事件监听器
    document.addEventListener('mousedown', handleClickOutside);

    // 清除事件监听器
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="tabbarBottom homePage">
        <div className="homePage-top-bg" >
          <img src={introduction_1Png} alt="介绍" />
        </div>
        <Popover
          content={<CityTabs onClick={(value) => _handleSelectCity(value)} />}
          placement="bottom"
          getPopupContainer={(triggerNode) => triggerNode}
          autoAdjustOverflow={false}
          open={cityTabsOpen}
        >
          <div className="homePageSearch"
            ref={targetRef}>
            <div className="left" onClick={() => {
              setCityTabsOpen(!cityTabsOpen)
            }}>
              <LocationOnIcon style={{ marginRight: '10px', fontSize: '20px' }} />
              <div>
                <div>{cityName}</div>
                <div>[切换城市]</div>
              </div>
            </div>
            <div className="right" onClick={() => {
              if (!token) {
                return router.navigate({
                  pathname: `/login`,
                  search: `?redirect=${encodeURIComponent(window.location.pathname)}`,
                })
              } else {
                router.navigate({
                  pathname: RoutePath.WMS_ZONE_SEARCH_FUZZY.path,
                })
              }
            }}>
              <SearchOutlined style={{ marginRight: '10px', fontSize: '20px', color: '#000000' }} />
              <div>
                <input placeholder="请输入仓库关键字进行搜索" />
                <span>(例如：品牌、子市场-乡镇)</span>
              </div>

            </div>
          </div>

        </Popover>
        <div className="recommend">
          <div className="recommend-title">分类推荐</div>
          <Tabs
            activeKey={activeKey}
            onChange={(key) => {
              setActiveKey(key)
            }}>
            {tabList &&
              tabList.length > 0 &&
              tabList.map((item) => {
                return (
                  <Tabs.TabPane
                    tab={item.name}
                    key={item.key}
                  ></Tabs.TabPane>
                )
              })}
          </Tabs>
          <div className="zoneItemList">
            {
              list && list.length > 0 &&
              list.map((item, index) => {
                return (
                  <div className="zoneItemWrap" key={index}>
                    <ZoneItem item={item} router={router} />
                  </div>
                )
              })
            }
          </div>
        </div>
      </div >
      <MTabBar router={router} index={0} />
    </>

  );
};


function mapStateToProps(store) {
  return {
    cityName: store.WMSZoneReducer.cityName,
  };
}

export default connect(mapStateToProps)(Home);
